import EventEmitter from "eventemitter3";
import React, { ReactElement, ReactNode, useEffect, useState  }  from "react";
import { Circles, DNA , Rings } from "react-loader-spinner";


export class ViewModel  {
    public updateAction :string = 'update'
    public eventEmitter = new EventEmitter(); 
    protected attatches:{viewModel:ViewModel , lis: React.Dispatch<React.SetStateAction<{viewModel:any}>>} [] = []

    public attachViewModel(viewModel:ViewModel , lis: React.Dispatch<React.SetStateAction<{viewModel:any}>>){
        this.attatches.push({viewModel:viewModel , lis:lis})
    }


    public update():void{
        this.eventEmitter?.emit(this.updateAction,  {viewModel:this});
        this.attatches?.forEach(ele=>{
            //ele.viewModel.eventEmitter?.emit(ele.viewModel.updateAction , {viewModel: ...ele.viewModel})
            //const New:ViewModel = ele.viewModel
            //ele.lis({viewModel:New})
            ele.viewModel.update()
        })
    }
    public subscribeUpdate(listener:React.Dispatch<React.SetStateAction<{viewModel:any}>>){
        this.eventEmitter?.on(this.updateAction,listener)

    }
    public unsubscribeUpdate(listener: React.Dispatch<React.SetStateAction<{viewModel:any}>>){
        this.eventEmitter?.off(this.updateAction,listener)

    }
}

export class InterActive extends ViewModel{
    //parameters
    private isLoading:boolean = false
    private messege:string = ''
    private spinner :ReactElement  = this.SpinnerJSX()
    private spinnerColor:string = 'var(--colorIII)'

    //getters
    public get IsLoading():boolean { return this.isLoading }
    public get Messege():string { return this.messege }
    public get Spinner():ReactElement { return this.spinner }
    protected get SpinnerColor():string { return this.spinnerColor }

    //setters
    protected set IsLoading(value:boolean) { this.isLoading= value ; this.update() }
    protected set Messege(value:string) { this.messege= value ; this.update() }
    protected set Spinner(value:ReactElement) { this.spinner = value; this.update() }
    protected set SpinnerColor(value:string) { this.spinnerColor = value ; this.update() }

    //constructor
    constructor(){ super() }

    //interactive
    public async loading(action : ()=>Promise<void>){
        if(!this.IsLoading){
        this.IsLoading = true
        await action()
        this.IsLoading = false}
    }

    public SpinnerJSX():ReactElement{
        const DefaulElement:ReactElement =  
        <div className="d-flex justify-content-center align-content-center">
        <div>
  
        <Rings 
              visible={true}
              height="80"
              width="80"
                  ariaLabel="dna-loading"
              wrapperStyle={{}}
              wrapperClass="dna-wrapper"
              />
      </div>
      </div>
        return(
            DefaulElement
        )
    }

    public Show(content:ReactElement|ReactNode|null):ReactElement|ReactNode|null{
        return this.IsLoading?this.Spinner:content
    }
    public ShowWithMessege(content:ReactElement|ReactNode|null):ReactElement|ReactNode|null{
        return this.IsLoading?this.spinner:(this.Messege===''?content:(<div className="d-flex justify-content-center align-content-center">{this.Messege}</div>))
    }
    protected getQueryParameter(key:string):string {
        return new URLSearchParams(window.location.search).get(key)||''
    }
}

export const useVM = <T extends InterActive>(initial:T)=>{
    const [state , setState] = useState<{viewModel:T}>({viewModel:initial})
    useEffect(()=>state.viewModel.subscribeUpdate(setState),[])
    return state.viewModel;
}